import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../../utils/router";
import Form from "./Form";
import { postRequest, withRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import { formatDate, getLink } from "../../../utils/helpers";
import Modal from "../../general/Modal";
import Loader from "../../general/Loader";

class Create extends Component {
    state = {
        errors: {},
        grupo: {},
        codigo: {},
        showSearch: false,
        search: "",
        searchResults: null,
        searchSuccess: null,
        searching: false,
    };
    componentDidMount() {
        this.getCodigo();
    }
    createGrupo = async (event) => {
        event.preventDefault();
        const data = new FormData(event.target);

        const response = await postRequest(apiUrl("gi-grupos"), data);

        if (response.success) {
            this.props.history.push(getLink("/gi-grupos"));
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    getTipos = async (url = null) => {
        url = url ? url : "tipos";
        const tipos = await this.props.request(url);

        if (tipos.data) {
            this.setState({
                tipos: tipos.data,
            });
        }
    };
    getCodigo = async (url = null) => {
        url = url ? url : "gi-grupos/codigo";
        const codigo = await this.props.request(url);

        if (codigo.data) {
            this.setState({
                codigo: codigo.data,
            });
        }
    };
    toggleSearchModal = () => {
        this.setState({
            showSearch: !this.state.showSearch,
        });
    };
    buscarGrupo = async (e) => {
        e.preventDefault();

        this.setState({
            searching: true,
        });

        const { search } = this.state;
        const url = `https://app.migente.com.do/api/getpadronexterno/?cedula=${search}&user=felipe_api&pswd=F3l1pe`;
        const response = await fetch(url);
        response.json().then((res) => {
            this.setState({
                searchResults: res.Persona,
                searchSuccess: res.Existe,
                searching: false,
            });
        });
    };
    insertarGrupo = () => {
        const search = this.state.searchResults;

        if (!search) {
            return;
        }

        this.setState({
            grupo: {
                nombre: search.Nombres,
                apellido:
                    search.Apellido1 +
                    " " +
                    (search.Apellido2 ? search.Apellido2 : ""),
                cedula: search.Cedula,
                fechaNacimiento: formatDate(Date.parse(search.FechaNacimiento)),
                direccion: search.Municipio + ", " + search.Provincia,
                foto: search.Imagen,
                fotoCed: search.Imagen,
            },
        });
        this.toggleSearchModal();
    };
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    render() {
        const {
            errors,
            grupo,
            codigo,
            searchResults,
            searching,
            searchSuccess,
        } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <h1 className='page-title'>
                        Añadir Grupo
                        <button
                            type='button'
                            onClick={this.toggleSearchModal}
                            className='btn btn-primary float-right'>
                            <i className='fas fa-search'></i>
                        </button>
                    </h1>
                </div>
                <div className='col-md-8 offset-2'>
                    <form
                        method='post'
                        onSubmit={this.createGrupo}
                        encType='multipart/form-data'>
                        <Form
                            grupo={grupo}
                            errors={errors}
                            codigo={codigo}
                        />
                        <div className='page-footer text-right'>
                            <Link
                                to={getLink("/grupos")}
                                className='btn btn-plain'>
                                Cancelar
                            </Link>
                            <button type='submit' className='btn btn-primary'>
                                Crear
                            </button>
                        </div>
                    </form>
                </div>
                <Modal
                    show={this.state.showSearch}
                    blank={true}
                    toggle={this.toggleSearchModal}>
                    <div className='popup__header'>Buscar Grupo</div>
                    <div>
                        <form onSubmit={this.buscarGrupo}>
                            <div className='search-cedula'>
                                <div className='row'>
                                    <div className='col'>
                                        <input
                                            name='search'
                                            onChange={this.onInputChange}
                                            type='text'
                                            className='form-control search'
                                        />
                                    </div>
                                    <div className='col-md-2'>
                                        <button className='btn btn-primary'>
                                            <i className='fas fa-search'></i>
                                        </button>
                                    </div>
                                </div>
                                {searching && <Loader />}
                                {searchResults && searchSuccess && (
                                    <div>
                                        <table className='table'>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    <img
                                                        alt={
                                                            searchResults.Nombres
                                                        }
                                                        src={`data:image/jpeg;base64,${searchResults.Imagen}`}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Nombre:</td>
                                                <td>{searchResults.Nombres}</td>
                                            </tr>
                                            <tr>
                                                <td>Apellido:</td>
                                                <td>
                                                    {searchResults.Apellido1}{" "}
                                                    {searchResults.Apellido2}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Fecha Nacimiento:</td>
                                                <td>
                                                    {
                                                        searchResults.FechaNacimiento
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Cédula:</td>
                                                <td>{searchResults.Cedula}</td>
                                            </tr>
                                            <tr>
                                                <td>Dirección:</td>
                                                <td>
                                                    {searchResults.Municipio},{" "}
                                                    {searchResults.Provincia}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                )}
                                {searchSuccess === false && (
                                    <div>
                                        No hay resultados para esta cédula.
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className='popup__footer'>
                        <button
                            type='button'
                            onClick={this.toggleSearchModal}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button
                            type='submit'
                            onClick={this.insertarGrupo}
                            className='btn btn-primary'>
                            Insertar
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(Create));
